import React, { ComponentType, PropsWithChildren } from 'react';
import { NestedHigherOrderComponent } from '@landr/mfe';
import { PaidDownloadUpsellModalProvider } from './UpsellModals/PaidDownloadUpsellModalContext';

export const PaidDownloadUpsellModalImport = () =>
    import('./UpsellModals/PaidDownloadUpsellModal').then((module) => ({
        default: module.PaidDownloadUpsellModal,
    }));

const ModalProvidersList: ComponentType[] = [PaidDownloadUpsellModalProvider];

export const ModalProviders: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <NestedHigherOrderComponent data={ModalProvidersList}>
            {children}
        </NestedHigherOrderComponent>
    );
};
